export default "__VITE_ASSET__CxUC2SQI__"